import { Injector } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { IBaseConfigurationFormModel } from '../../../../models/form-builder-types-configurations.model';
import {
  defaultTextareaConfigFormModel,
  textareaFieldParseIntoSettingsFormModel,
  textareaFieldUpdateFromSettingsFormModel,
} from '../textarea-field-type.configuration';
import { BaseFormlyFieldConfiguration } from './base-formly-field-configuration';

export class TextareaFormlyFieldConfiguration extends BaseFormlyFieldConfiguration {
  constructor(injector: Injector, field: FormlyFieldConfig) {
    super(injector, field);

    this.availableValidations.push('minLength', 'maxLength');
    this.availableConditionalValidations.push('minLength', 'maxLength');
    this.settingsFormlyModel = defaultTextareaConfigFormModel;
  }

  override parseFieldConfigIntoSettingsFormModel(): IBaseConfigurationFormModel {
    return textareaFieldParseIntoSettingsFormModel(this.field);
  }

  override updateFieldConfigFromSettingsFormModel(
    model: any
  ): FormlyFieldConfig {
    return textareaFieldUpdateFromSettingsFormModel(model, this.field);
  }
}
